import { render, staticRenderFns } from "./IISSiteSendReceiveByteChart.vue?vue&type=template&id=28b22e60&"
import script from "./IISSiteSendReceiveByteChart.vue?vue&type=script&lang=js&"
export * from "./IISSiteSendReceiveByteChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports